module.exports = __webpack_public_path__ + "static/media/emptyStateSearch.395e2a83.png";